import React, { useState } from 'react';

// TODO Add equivalent icons to DS and use here
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import AccountIcon from 'mdi-react/AccountIcon';

import * as S from './styles';

type OwnProps = {
  className?: string;
  size?: number;
  isLinked?: boolean;
};

type MeProps = {
  displayName?: string | null;
  avatar?: string | null;
  email?: string | null;
};

type Props = OwnProps & MeProps;

const DEFAULT_SIZE = 32;

export const UserAvatar = ({
  size = DEFAULT_SIZE,
  className,
  avatar,
  displayName,
  email,
  isLinked = true,
}: Props) => {
  const props = { avatar, displayName, email, size };
  const isLoggedIn = displayName || email;

  return (
    <S.UserAvatar
      className={className}
      data-test="UserAvatar"
      size={size}
      isLoggedIn={Boolean(isLoggedIn)}
      hasAvatar={Boolean(avatar)}
      $isLinked={isLinked}
    >
      <Symbol {...props} />
    </S.UserAvatar>
  );
};

export const Symbol = ({
  avatar,
  displayName,
  email,
  size = DEFAULT_SIZE,
}: Props) => {
  const [imageError, setImageError] = useState(false);

  const isLoggedIn = displayName || email;
  const validNameOrEmail = /^[A-Za-z]/;

  const onError = () => {
    setImageError(true);
  };

  if (isLoggedIn) {
    if (avatar && !imageError)
      return (
        <S.Image
          alt={displayName || email || ''}
          src={avatar}
          width={size}
          height={size}
          onError={onError}
        />
      );

    if (displayName && displayName.match(validNameOrEmail))
      return (
        <span style={{ lineHeight: `${size}px` }}>{displayName.charAt(0)}</span>
      );

    if (email && email.match(validNameOrEmail))
      return <span>{email.charAt(0)}</span>;

    return <AccountIcon color="currentColor" size={size * 0.75} />;
  }

  return <AccountOutlineIcon color="currentColor" size={size} />;
};
